import React from "react";
import {
    CheckCircle,
    GlobeHemisphereWest,
    ArrowLeft,
} from "@phosphor-icons/react";
import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import { useLanguage } from "../contexts/LanguageContext";

const languagePageTexts = {
    de: {
        title: "Sprache",
        subtitle: "Wähle deine Anzeigesprache für WORLDofRADIO.",
        backToDiscover: "Zurück zu Discover",
    },

    en: {
        title: "Language",
        subtitle: "Choose your display language for WORLDofRADIO.",
        backToDiscover: "Back to Discover",
    },

    no: {
        title: "Språk",
        subtitle: "Velg visningsspråk for WORLDofRADIO.",
        backToDiscover: "Tilbake til Discover",
    },

    ko: {
        title: "언어",
        subtitle: "WORLDofRADIO의 표시 언어를 선택하세요.",
        backToDiscover: "Discover로 돌아가기",
    },

    fi: {
        title: "Kieli",
        subtitle: "Valitse WORLDofRADIO:n näyttökieli.",
        backToDiscover: "Takaisin Discoveriin",
    },
};

const Language = () => {
    const { language, setLanguage, languages } = useLanguage();

    const text = languagePageTexts[language] || languagePageTexts.en;

    return (
        <div className="min-h-screen bg-[#050505] pb-40 md:pb-28">
            <Navbar />

            <main className="max-w-4xl mx-auto px-6 lg:px-8 py-12">
                <div className="mb-10">
                    <div className="flex items-center gap-3 mb-4">
                        <GlobeHemisphereWest
                            size={40}
                            weight="duotone"
                            className="text-cyan-400"
                        />

                        <h1
                            className="text-4xl sm:text-5xl tracking-tighter font-black text-white"
                            style={{ fontFamily: "Outfit, sans-serif" }}
                        >
                            {text.title}
                        </h1>
                    </div>

                    <p className="text-base text-gray-300">
                        {text.subtitle}
                    </p>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    {languages.map((item) => {
                        const isActive = language === item.code;

                        return (
                            <button
                                key={item.code}
                                type="button"
                                onClick={() => setLanguage(item.code)}
                                className={`w-full rounded-2xl border p-5 text-left transition-all ${isActive
                                    ? "border-cyan-400 bg-cyan-400/10 shadow-[0_0_20px_rgba(34,211,238,0.18)]"
                                    : "border-white/10 bg-[#0A0E17] hover:border-cyan-400/60 hover:bg-white/5"
                                    }`}
                            >
                                <div className="flex items-center justify-between gap-4">
                                    <div>
                                        <div
                                            className={`text-lg font-bold ${isActive ? "text-cyan-300" : "text-white"
                                                }`}
                                        >
                                            {item.name}
                                        </div>

                                        <div className="text-sm text-gray-400 mt-1">
                                            {item.label}
                                        </div>
                                    </div>

                                    {isActive && (
                                        <CheckCircle
                                            size={28}
                                            weight="fill"
                                            className="text-cyan-400 flex-shrink-0"
                                        />
                                    )}
                                </div>
                            </button>
                        );
                    })}
                </div>

                <div className="mt-10">
                    <Link
                        to="/discover"
                        className="inline-flex items-center gap-2 text-sm text-gray-400 hover:text-cyan-400 transition-colors"
                    >
                        <ArrowLeft size={16} />
                        {text.backToDiscover}
                    </Link>
                </div>
            </main>
        </div>
    );
};

export default Language;
